import { useEffect } from "react";

import { Card, Link as DSLink, Heading } from "@icg360/design-system";

import { trackEvent } from "utils";

import styles from "./featured-offers-affiliate-blog.module.scss";

export const FeaturedOfferAffiliateBlog = () => {
  useEffect(() => {
    trackEvent("Featured Offer Card Shown", {
      offerInternalName: "affiliate-blog",
    });
  });

  return (
    <Card className={styles.cardDS}>
      <Heading size="md">Home protection tips</Heading>
      <div className={styles.content}>
        <div className={styles.leftCopy}>
          <Heading size="sm" className={styles.heroTextDS}>
            Room by room:
          </Heading>
          <Heading size="lg" className={styles.heroTextDS}>
            Preventing damage in the laundry area
          </Heading>
          <DSLink
            appearance="primary"
            href="/my/resources/laundry-room"
            data-testid="affiliate-featured-btn"
          >
            Learn more
          </DSLink>
        </div>
        <div
          className={styles.imageWrapper}
          role="img"
          aria-label={
            "Image of a laundry room with a washer and dryer in focus"
          }
          title={"Image of a laundry room with a washer and dryer in focus"}
          style={{
            backgroundImage:
              "url(https://externalmedia-ss-prod.s3.us-east-1.amazonaws.com/sagesure/images/policyholder-offers/affiliate-blog/featured-offer-affiliate.jpg)",
          }}
        />
      </div>
    </Card>
  );
};
